import { useEffect } from 'react';

/**
 * Eski ekranlardaki tablolari dar ekranda karta cevirir.
 *
 * Yeni panolarda her hucreye elle data-etiket yazildi. Ama sistemde 20'yi
 * askin eski tablo var ve hepsini elle etiketlemek hem cok is hem hataya
 * acik (hucre sirasi kaydiginda etiketler yanlis satira duser).
 *
 * Bunun yerine etiketler CALISMA ANINDA baslik satirindan aliniyor:
 * tarayici zaten dogru esleme bilgisine sahip. Tek bir yerden butun
 * ekranlar mobil uyumlu hale geliyor.
 *
 * Guvenlik agi: hucre sayisi baslik sayisiyla uyusmayan satirlar
 * (colSpan kullananlar) etiketlenmiyor — yanlis etiket, etiketsiz
 * hucreden daha kotu.
 */

const ESIK = 768;

function etiketle(kok) {
  const tablolar = kok.querySelectorAll('table.ds-table');

  tablolar.forEach((tablo) => {
    // Elle etiketlenmis tablolara dokunma
    if (tablo.dataset.mobilElle === '1') return;

    const basliklar = [...tablo.querySelectorAll('thead th')].map((th) => th.textContent.trim());
    if (!basliklar.length) return;

    let etiketlenen = 0;
    tablo.querySelectorAll('tbody tr').forEach((satir) => {
      const hucreler = satir.children;
      if (hucreler.length !== basliklar.length) return; // colSpan vb.
      for (let i = 0; i < hucreler.length; i += 1) {
        const h = hucreler[i];
        if (h.hasAttribute('data-etiket')) continue;
        if (!basliklar[i]) continue;             // bos baslik = etiketsiz sutun
        h.setAttribute('data-etiket', basliklar[i]);
        etiketlenen += 1;
      }
    });

    if (etiketlenen) tablo.classList.add('ds-tablo-kart');
  });
}

/**
 * Layout'ta bir kez cagriliyor.
 *
 * Sayfa gecisleri ve veri yuklemeleri DOM'u degistirdigi icin
 * MutationObserver kullaniliyor; her degisiklikte degil, kisa bir
 * gecikmeyle toplu calisiyor.
 */
export default function useMobilTablo() {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    let zamanlayici = null;
    const planla = () => {
      if (window.innerWidth > ESIK) return;
      clearTimeout(zamanlayici);
      zamanlayici = setTimeout(() => etiketle(document), 120);
    };

    planla();

    const gozlemci = new MutationObserver(planla);
    gozlemci.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', planla);

    return () => {
      clearTimeout(zamanlayici);
      gozlemci.disconnect();
      window.removeEventListener('resize', planla);
    };
  }, []);
}
